import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/vercel/path0/middleware/auth.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}